import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class UserService {
  static getUserDetails() {
    return HttpUtil.get(API_ROUTES.USER.GETUSERDETAILS);
  }

  static getCompanyLogo(companyId) {
    return API_ROUTES.TENANT.LOGO.replace("<companyId>", companyId);
  }
}
